export default {
  recipeFilterNotAvailable: 'Select an asset before filtering by recipe',
};
